import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { Person } from '../../../models/Entities/Person/Person';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';

import * as MedicalProtocolStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as PersonsStore from '../../../redux/middleware/Persons.Middleware';
import * as PractitionerStore from '../../../redux/middleware/PractitionerMiddleware';

import { AppState } from '../../../redux/reducers';

/**
 * Conexión del panel financiero.
 *
 * Las cifras de caja se piden directo al servicio de estadísticas —son de lectura y
 * de esta pantalla sola—, pero del store salen tres cosas que sí se comparten: la
 * lista de protocolos (para la rentabilidad protocolo por protocolo) y las personas
 * y prestadores, que son los que permiten mostrar un nombre en vez del identificador
 * crudo en el ranking de deudores.
 */

interface IProps {
    /** Vuelve a pedir todo cuando cambia; lo usa el botón de refrescar. */
    refreshTick?: number;
}

interface ConnectedProps {
    MedicalProtocols: Protocol[];
    IsLoadingProtocols: boolean;
    Persons: Person[];
    Practitioners: Practitioner[];
    AccessToken: string | undefined;
}

interface DispatchProps {
    GetAllMedicalProtocols: typeof MedicalProtocolStore.actionCreators.GetAllMedicalProtocols;
    GetAllPersons: typeof PersonsStore.actionCreators.GetAllPersons;
    GetAllPractitioners: typeof PractitionerStore.actionCreators.GetAllPractitioners;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState) => ({
    MedicalProtocols: state.MedicalProtocols?.list ?? [],
    IsLoadingProtocols: !!state.MedicalProtocols?.isLoadingAll,
    Persons: state.Persons?.list ?? [],
    Practitioners: state.Practitioners?.list ?? [],
    AccessToken: (state as any)?.oidc?.user?.access_token as string | undefined
});

export const mapDispatchToProps = {
    GetAllMedicalProtocols: MedicalProtocolStore.actionCreators.GetAllMedicalProtocols,
    GetAllPersons: PersonsStore.actionCreators.GetAllPersons,
    GetAllPractitioners: PractitionerStore.actionCreators.GetAllPractitioners
};
